import { Box } from "@mui/material";
import AddReactionOutlinedIcon from "@mui/icons-material/AddReactionOutlined";
import emoji from "emoji-dictionary";
import TooltipDark from "utils/TooltipDark";
import WinWireReplyOptions from "./WinWireReplyOptions";

const EmojiBox = ({
  handleReactionClick,
  handleOpenEmojiPopover,
  showOptions = false,
  handleEditClick,
  handleDeleteClick,
  isOwner = false,
}) => {
  const emojiShortcodes = [":smiley:", ":fire:", ":heart:", ":clap:", ":star:"];

  return (
    <Box className="emoji-box">
      {emojiShortcodes.map((shortcode) => (
        <Box
          key={shortcode}
          className="emoji-box-emoji"
          role="img"
          aria-label={shortcode}
          onClick={() => handleReactionClick(shortcode)}
        >
          {emoji.getUnicode(shortcode)}
        </Box>
      ))}
      <TooltipDark title="Add reaction" placement="top">
        <Box className="emoji-box-emoji" onClick={handleOpenEmojiPopover}>
          <AddReactionOutlinedIcon className="add-reaction-emoji" />
        </Box>
      </TooltipDark>
      {showOptions && (
        <Box className="emoji-box-emoji">
          <WinWireReplyOptions
            handleEditClick={handleEditClick}
            handleDeleteClick={handleDeleteClick}
            isOwner={isOwner}
          />
        </Box>
      )}
    </Box>
  );
};

export default EmojiBox;
